module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/venue-img-five-5ccb7cea49ce3e2a9d337bab692732ac.jpg";